import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-profile",
  templateUrl: "./med-icon-profile.component.html",
})
export class MedIconProfileComponent extends SvgMixinComponent {}
